import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import WagonNumberAutoComplete from '../../WagonNumberAutocomplete/WagonNumberAutocomplete';
import HistoricPopUp from '../../TicketDetails/HistoricPopUp/HistoricPopUp';
import useStyles from './styles';
import ApiService from '../../../services/ApiService';
import DeleteAllPopUp from '../ConfirmationPopUps/DeleteAllPopUp';

export default function InvoiceDetails(props) {
  const {
    defaultInvoices,
    activityType,
    isCancelling,
    saveValidationErrors,
    editMode,
  } = props;

  const initialTicket = [
    {
      ticketNumber: '',
    },
  ];
  const initialInvoice = {
    manualInput: true,
    eventDate: new Date(),
    wagonNumber: '',
    activityType: '',
    amount: 0,
    maintenanceTicketInvoiceList: initialTicket,
  };
  const [invoices, setInvoices] = React.useState([initialInvoice]);
  const [validationErrors, setValidationErrors] = React.useState([]);
  const [tickets, setTickets] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [historicOpened, setHistoricOpened] = React.useState(false);
  const [selectedTicketNumber, setSelectedTicketNumber] = React.useState('');

  const [savingValidationErrors, setSavingValidationErrors] = React.useState(
    [],
  );
  const [openDeletAllInvoicesPopUp, setOpenDeleteAllInvoicesPopUp] =
    React.useState(false);

  const classes = useStyles();
  const { t } = useTranslation();

  const dateFormatter = (date) => {
    return [date.getDate(), date.getMonth() + 1, date.getFullYear()]
      .map((n) => (n < 10 ? `0${n}` : `${n}`))
      .join('/');
  };
  const eventDateFormatter = (date) => {
    if (moment(date, 'DD/MM/YYYY').isValid()) {
      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    return date;
  };

  function hasFieldValueError(index, field) {
    let hasError = false;
    if (
      savingValidationErrors !== undefined &&
      savingValidationErrors[index] !== null &&
      savingValidationErrors[index] !== undefined
    ) {
      if (
        field === 'activityType' &&
        savingValidationErrors[index][field] !== undefined &&
        savingValidationErrors[index][field] !== null
      ) {
        hasError = !savingValidationErrors[index][field];
      } else if (
        savingValidationErrors[index][field] !== undefined &&
        savingValidationErrors[index][field] !== null
      ) {
        hasError = true;
      }
    }
    return hasError;
  }

  function hasActivityTypeError(activity) {
    if (activity === null || activity === undefined) return true;
    if (
      activity !== 'cleaning' &&
      activity !== 'transport' &&
      activity !== 'repair' &&
      activity !== 'others'
    )
      return true;
    return false;
  }

  useEffect(() => {
    const defaultInvoicesModified = defaultInvoices.slice();
    if (editMode) {
      defaultInvoicesModified.forEach((invoice) => {
        invoice.eventDate = eventDateFormatter(invoice.eventDate);
      });
    }
    setInvoices(defaultInvoicesModified);
    const wagonList = defaultInvoices.map((invoice, index) => {
      if (
        hasActivityTypeError(invoice.activityType) &&
        invoice.wagonNumber &&
        invoice.wagonNumber !== ''
      ) {
        if (
          savingValidationErrors[index] !== undefined ||
          savingValidationErrors[index] !== null
        ) {
          savingValidationErrors[index] = {
            ...savingValidationErrors[index],
            activityType: false,
          };
        } else {
          savingValidationErrors[index] = { activityType: false };
        }
      } else {
        savingValidationErrors[index] = {
          ...savingValidationErrors[index],
          activityType: true,
        };
      }
      return invoice.wagonNumber;
    });
    const mutatedSavingValidationErrors = [...savingValidationErrors];
    setSavingValidationErrors(mutatedSavingValidationErrors);
    if (!(wagonList.length === 1 && wagonList[0] === '')) {
      ApiService.getAllTicketsForWagonList([...new Set(wagonList)]).then(
        (response) => {
          setTickets(response.data);
        },
      );
    }
  }, [defaultInvoices, activityType]);

  useEffect(() => {
    setSavingValidationErrors(saveValidationErrors);
  }, [saveValidationErrors]);

  useEffect(() => {
    if (!editMode) {
      if (isCancelling) {
        setValidationErrors([]);
        props.cancelOver();
      } else {
        const invoicesModified = invoices.slice();
        invoicesModified.forEach((invoice) => {
          invoice.activityType = activityType;
        });
        setInvoices(invoicesModified);
        props.sendAllInvoices(invoicesModified);
      }
    }
  }, [activityType]);

  function deleteInvoice(invoiceIndex) {
    const invoicesModified = invoices.slice();
    invoicesModified.splice(invoiceIndex, 1);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }

  function addInvoice() {
    const prefilledInvoice = {
      ...initialInvoice,
      activityType,
    };
    const invoicesModified = invoices.slice();
    invoicesModified.push(prefilledInvoice);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }

  function handleChangeInvoiceEventDate(invoiceIndex, date) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.eventDate = date;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }

  function addTicketsForWagon(wagonNumber) {
    const ticketsForWagon = tickets.filter(
      (ticket) => ticket.wagonNumber === wagonNumber,
    );
    if (
      wagonNumber !== '' &&
      wagonNumber.length === 12 &&
      ticketsForWagon.length === 0
    ) {
      ApiService.getAllTicketsForWagonList([wagonNumber]).then((response) => {
        const ticketsToUpdate = tickets.slice();
        setTickets(ticketsToUpdate.concat(response.data));
      });
    }
  }

  function handleChangeInvoiceWagonNumber(invoiceIndex, wagonNumber) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.wagonNumber = wagonNumber;
    if (wagonNumber === '') {
      invoiceToUpdate.maintenanceTicketInvoiceList = initialTicket;
    }
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    addTicketsForWagon(wagonNumber);
    props.sendAllInvoices(invoicesModified);
  }

  function handleChangeInvoiceActivityType(invoiceIndex, activityTypeSelected) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.activityType = activityTypeSelected;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }

  function handleChangeInvoiceAmount(invoiceIndex, amount) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.amount = amount;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }

  function handleChangeTicketNumberForInvoice(
    invoiceIndex,
    ticketIndex,
    ticketNumber,
    event,
  ) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    let ticketSelected;
    if (ticketNumber === '' && event !== null) {
      ticketSelected = {
        ticketNumber: '',
      };
      invoiceToUpdate.maintenanceTicketInvoiceList.splice(
        ticketIndex,
        1,
        ticketSelected,
      );
      invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
      setInvoices(invoicesModified);
      props.sendAllInvoices(invoicesModified);
    } else if (ticketNumber !== '') {
      const ticketOption = tickets.find(
        (ticket) => ticket.ticketNumber === ticketNumber,
      );
      ticketSelected = { ...ticketOption, selected: true };
      invoiceToUpdate.maintenanceTicketInvoiceList.forEach((item) => {
        item.selected = false;
      });
      invoiceToUpdate.maintenanceTicketInvoiceList.splice(
        ticketIndex,
        1,
        ticketSelected,
      );
      invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
      setInvoices(invoicesModified);
      props.sendAllInvoices(invoicesModified);
    }
  }

  const setOptionSelected = (option, value) => {
    return option.ticketNumber === value.ticketNumber;
  };

  function setOptionLabel(option) {
    return option.ticketNumber ? option.ticketNumber : '';
  }

  function getTicketOptionsForWagonNumber(
    invoiceIndex,
    ticketIndex,
    wagonNumber,
  ) {
    const wagonTickets = tickets.filter(
      (ticket) => ticket.wagonNumber === wagonNumber,
    );
    const matchingTicketList = invoices[
      invoiceIndex
    ].maintenanceTicketInvoiceList.map((ticket) => {
      return ticket.ticketNumber;
    });
    const ticketListNotInMatching = wagonTickets.filter(
      (ticket) => !matchingTicketList.includes(ticket.ticketNumber),
    );
    const defaultTicket =
      invoices[invoiceIndex].maintenanceTicketInvoiceList[ticketIndex];
    if (defaultTicket.ticketNumber === '') {
      return ticketListNotInMatching;
    }
    ticketListNotInMatching.push(defaultTicket);
    return ticketListNotInMatching;
  }
  function match() {
    setLoading(true);
    const manualInvoices = invoices.filter((invoice) => invoice.manualInput);
    ApiService.matchInvoicesWithTickets(manualInvoices)
      .then((response) => {
        const manualInvoicesResult = response.data.map((invoice) => {
          const numberOfTicket = invoice.maintenanceTicketInvoiceList.length;
          const ticketsWithSelectedField =
            invoice.maintenanceTicketInvoiceList.map((ticket) => {
              return { ...ticket, selected: numberOfTicket === 1 };
            });
          return {
            ...invoice,
            maintenanceTicketInvoiceList: ticketsWithSelectedField,
            manualInput: true,
          };
        });
        const excelInvoices = invoices.filter(
          (invoice) => invoice.manualInput === false,
        );

        const invoicesModified = [...excelInvoices, ...manualInvoicesResult];
        invoicesModified.forEach((invoice) => {
          if (invoice.eventDate == null) {
            invoice.eventDate = new Date();
          }
          if (invoice.invoiceDate == null) {
            invoice.invoiceDate = new Date();
          }
        });
        setInvoices(invoicesModified);
        props.sendAllInvoices(invoicesModified);
        setLoading(false);
      })
      .catch((error) => {
        if (error) {
          const validationErrorsForInvoices = [];
          let errorIndex = 0;
          invoices.forEach((invoice) => {
            if (invoice.manualInput) {
              validationErrorsForInvoices.push(error[errorIndex]);
              errorIndex += 1;
            } else {
              validationErrorsForInvoices.push(null);
            }
          });
          setValidationErrors(validationErrorsForInvoices);
        }
        setLoading(false);
      });
  }

  function openHistoricForTicket(ticketNumber) {
    setSelectedTicketNumber(ticketNumber);
    setHistoricOpened(true);
  }

  function closeHistoric() {
    setHistoricOpened(false);
  }

  function handleSelectedTicket(ticketNumber, invoiceIndex, value) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.maintenanceTicketInvoiceList.forEach((item) => {
      item.selected = ticketNumber === item.ticketNumber && value;
    });
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }
  function removeMatchingValidationErrors(error, index) {
    if (error === null) {
      const copy = validationErrors.slice();
      copy[index] = null;
      setValidationErrors(copy);
    }
  }

  function removeValidationError(index, field) {
    const errors = savingValidationErrors.slice();
    const invoice = errors[index];
    if (invoice !== undefined) {
      invoice[field] = null;
      setSavingValidationErrors(errors);
    }
  }
  function handleChangeInvoiceNumber(invoiceIndex, invoiceNumber) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.invoiceNumber = invoiceNumber;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }
  function handleChangeSupplier(invoiceIndex, supplier) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.supplier = supplier;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }
  function handleChangeInvoiceDate(invoiceIndex, invoiceDate) {
    const invoicesModified = invoices.slice();
    const invoiceToUpdate = invoicesModified[invoiceIndex];
    invoiceToUpdate.invoiceDate = invoiceDate;
    invoicesModified.splice(invoiceIndex, 1, invoiceToUpdate);
    setInvoices(invoicesModified);
    props.sendAllInvoices(invoicesModified);
  }
  function deleteAll() {
    setInvoices([]);
    props.sendAllInvoices([]);
    setOpenDeleteAllInvoicesPopUp(false);
  }

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.invoicePaper}>
        {loading && (
          <Paper
            elevation={0}
            position="absolute"
            zindex="2"
            data-testid="loader"
          >
            <CircularProgress className={classes.loader} />
          </Paper>
        )}
        <Grid
          container
          spacing={0}
          className={editMode ? classes.gridMinWidth : null}
        >
          <Grid container item xs={editMode ? 8 : 6}>
            <Grid container className={classes.container}>
              <Grid container item xs={editMode ? 5 : 1}>
                <Grid item xs={editMode ? 2 : 12}>
                  <IconButton
                    aria-label="delete-all"
                    className={classes.removeAllButton}
                    onClick={() => setOpenDeleteAllInvoicesPopUp(true)}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Grid>
                {editMode && (
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Invoice number')}
                    </FormLabel>
                  </Grid>
                )}
                {editMode && (
                  <Grid item xs={3}>
                    <FormLabel className={classes.formLabel}>
                      {t('Supplier')}
                    </FormLabel>
                  </Grid>
                )}
                {editMode && (
                  <Grid item xs={4}>
                    <FormLabel className={classes.formLabel}>
                      {t('Invoice date')}
                    </FormLabel>
                  </Grid>
                )}
              </Grid>
              <Grid container item xs={editMode ? 7 : 11}>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Event date')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Wagon number')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3} container justify="flex-start">
                  <FormLabel className={classes.formLabel}>
                    {t('Activity type')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Amount')}
                  </FormLabel>
                </Grid>
              </Grid>
            </Grid>
            {invoices.map((invoice, index) => {
              const invoiceId = `invoice-${index}`;
              return (
                <Grid container key={invoiceId} data-testid="invoice-row">
                  <Grid container className={classes.row}>
                    <Grid container item xs={editMode ? 5 : 1}>
                      <Grid item xs={editMode ? 2 : 12}>
                        <IconButton
                          aria-label="delete-invoice"
                          className={classes.removeButton}
                          onClick={() => deleteInvoice(index)}
                        >
                          <RemoveCircleOutlineIcon />
                        </IconButton>
                      </Grid>
                      {editMode && (
                        <Grid item xs={3}>
                          <TextField
                            inputProps={{
                              'data-testid': 'invoice-number',
                              className: classes.inputStyle,
                            }}
                            className={classes.input}
                            variant="outlined"
                            size="small"
                            value={invoice.invoiceNumber || ''}
                            onChange={(e) => {
                              handleChangeInvoiceNumber(index, e.target.value);
                              removeValidationError(index, 'invoiceNumber');
                            }}
                            error={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== null &&
                              savingValidationErrors[index] !== undefined &&
                              savingValidationErrors[index].invoiceNumber !==
                                undefined &&
                              savingValidationErrors[index].invoiceNumber !==
                                null
                            }
                            helperText={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== undefined
                                ? savingValidationErrors[index].invoiceNumber
                                : null
                            }
                            FormHelperTextProps={{
                              className: classes.helperText,
                            }}
                          />
                        </Grid>
                      )}
                      {editMode && (
                        <Grid item xs={3}>
                          <TextField
                            data-testid="supplier"
                            className={classes.input}
                            inputProps={{
                              className: classes.inputStyle,
                            }}
                            variant="outlined"
                            size="small"
                            value={invoice.supplier || ''}
                            onChange={(e) => {
                              handleChangeSupplier(index, e.target.value);
                              removeValidationError(index, 'supplier');
                            }}
                            error={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== null &&
                              savingValidationErrors[index] !== undefined &&
                              savingValidationErrors[index].supplier !==
                                undefined &&
                              savingValidationErrors[index].supplier !== null
                            }
                            helperText={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== undefined
                                ? savingValidationErrors[index].supplier
                                : null
                            }
                            FormHelperTextProps={{
                              className: classes.helperText,
                            }}
                          />
                        </Grid>
                      )}
                      {editMode && (
                        <Grid item xs={4}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              data-testid="invoice-date"
                              InputProps={{ className: classes.datePicker }}
                              disableToolbar
                              inputVariant="outlined"
                              size="small"
                              format="dd/MM/yyyy"
                              value={invoice.invoiceDate || new Date()}
                              onChange={(date) => {
                                handleChangeInvoiceDate(index, date);
                              }}
                              FormHelperTextProps={{
                                className: classes.helperText,
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container item xs={editMode ? 7 : 11}>
                      <Grid item xs={3} container justify="flex-start">
                        {!invoice.manualInput &&
                        (invoice.eventDate !== '-' ||
                          invoice.eventDate === null) ? (
                          <FormLabel
                            className={
                              hasFieldValueError(index, 'tktSelected')
                                ? classes.formLabelHighlighted
                                : classes.label
                            }
                          >
                            {dateFormatter(invoice.eventDate)}
                          </FormLabel>
                        ) : (
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              data-testid="event-date"
                              InputProps={{ className: classes.datePicker }}
                              disableToolbar
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              size="small"
                              value={
                                invoice.eventDate !== '-' &&
                                invoice.eventDate !== null
                                  ? invoice.eventDate
                                  : new Date()
                              }
                              onChange={(date) => {
                                handleChangeInvoiceEventDate(index, date);
                              }}
                              FormHelperTextProps={{
                                className: classes.helperText,
                              }}
                              className={
                                hasFieldValueError(index, 'tktSelected')
                                  ? classes.inputBoxHighlighted
                                  : ''
                              }
                            />
                          </MuiPickersUtilsProvider>
                        )}
                      </Grid>
                      <Grid item xs={3} container justify="flex-start">
                        {!invoice.manualInput ? (
                          <FormLabel
                            className={
                              hasFieldValueError(index, 'tktSelected')
                                ? classes.formLabelHighlighted
                                : classes.label
                            }
                          >
                            {invoice.wagonNumber}
                          </FormLabel>
                        ) : (
                          <span
                            className={
                              hasFieldValueError(index, 'tktSelected')
                                ? classes.inputBoxHighlighted
                                : ''
                            }
                          >
                            <WagonNumberAutoComplete
                              disabled={!invoice.manualInput}
                              wagonNumber={invoice.wagonNumber}
                              addingInvoice
                              deletedIntegrated
                              errorPresent={
                                (validationErrors[index] !== null &&
                                  validationErrors[index] !== undefined) ||
                                (savingValidationErrors !== undefined &&
                                  savingValidationErrors[index] !== null &&
                                  savingValidationErrors[index] !== undefined &&
                                  savingValidationErrors[index].wagonNumber !==
                                    undefined &&
                                  savingValidationErrors[index].wagonNumber !==
                                    null)
                              }
                              errorMessage={
                                validationErrors[index] ||
                                (savingValidationErrors !== undefined &&
                                savingValidationErrors[index] !== undefined
                                  ? savingValidationErrors[index].wagonNumber
                                  : null)
                              }
                              setErrorPresent={(error) =>
                                removeMatchingValidationErrors(error, index)
                              }
                              setErrorMessage={(error) =>
                                removeMatchingValidationErrors(error, index)
                              }
                              setWagonNumber={(wagonNumber) => {
                                handleChangeInvoiceWagonNumber(
                                  index,
                                  wagonNumber,
                                );
                                removeValidationError(index, 'wagonNumber');
                              }}
                            />
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={3} container justify="flex-start">
                        <FormControl
                          className={
                            editMode
                              ? classes.activityInput
                              : hasFieldValueError(index, 'tktSelected')
                              ? `${classes.inputBoxHighlighted} ${classes.activityInputHighlight}`
                              : classes.activityType
                          }
                          error={hasFieldValueError(index, 'activityType')}
                        >
                          <Select
                            data-testid="activity-type"
                            variant="outlined"
                            displayEmpty
                            className={classes.select}
                            inputProps={{ 'aria-label': 'Without label' }}
                            MenuProps={{
                              classes: { paper: classes.label },
                            }}
                            value={invoice.activityType}
                            onChange={(e) => {
                              handleChangeInvoiceActivityType(
                                index,
                                e.target.value,
                              );
                            }}
                          >
                            <MenuItem value="" disabled>
                              {t('Select an activity type')}
                            </MenuItem>
                            <MenuItem value="cleaning">
                              {' '}
                              {t('Cleaning')}
                            </MenuItem>
                            <MenuItem value="transport">
                              {t('Transport')}
                            </MenuItem>
                            <MenuItem value="repair">{t('Repair')}</MenuItem>
                            <MenuItem value="others"> {t('others')}</MenuItem>
                          </Select>
                          {hasFieldValueError(index, 'activityType') && (
                            <FormHelperText className={classes.helperText}>
                              {t('Activity type is missing')}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={3} container justify="flex-start">
                        {!invoice.manualInput && invoice.amount !== 0.0 ? (
                          <FormLabel
                            className={
                              hasFieldValueError(index, 'tktSelected')
                                ? `${classes.formLabelHighlighted} ${classes.margin12}`
                                : classes.amountLabel
                            }
                          >
                            {invoice.amount}
                          </FormLabel>
                        ) : (
                          <CurrencyTextField
                            inputProps={{
                              'data-testid': 'amount',
                            }}
                            variant="standard"
                            value={invoice.amount}
                            currencySymbol="€"
                            outputFormat="string"
                            decimalCharacter="."
                            digitGroupSeparator=""
                            className={
                              hasFieldValueError(index, 'tktSelected')
                                ? classes.formLabelHighlighted
                                : classes.currencyInput
                            }
                            onBlur={(event, value) => {
                              handleChangeInvoiceAmount(index, value);
                              removeValidationError(index, 'amount');
                            }}
                            error={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== null &&
                              savingValidationErrors[index] !== undefined &&
                              savingValidationErrors[index].amount !==
                                undefined &&
                              savingValidationErrors[index].amount !== null
                            }
                            helperText={
                              savingValidationErrors !== undefined &&
                              savingValidationErrors[index] !== undefined
                                ? savingValidationErrors[index].amount
                                : null
                            }
                            FormHelperTextProps={{
                              className: classes.helperText,
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  {invoice.maintenanceTicketInvoiceList !== undefined &&
                    invoice.maintenanceTicketInvoiceList.length !== 0 &&
                    invoice.maintenanceTicketInvoiceList.map(
                      (ticket, ticketIndex) => {
                        const emptyInvoiceId = `invoice-empty-${ticketIndex}`;
                        return (
                          ticketIndex !==
                            invoice.maintenanceTicketInvoiceList.length - 1 && (
                            <Grid
                              item
                              xs={12}
                              key={emptyInvoiceId}
                              className={classes.row}
                            />
                          )
                        );
                      },
                    )}
                </Grid>
              );
            })}
          </Grid>
          <Tooltip
            TransitionComponent={Fade}
            title={t('matching description')}
            arrow
          >
            <IconButton
              aria-label="matching-ticket"
              data-testid="match"
              onClick={match}
              className={
                editMode ? classes.editMatchButton : classes.matchButton
              }
            >
              <AutorenewIcon aria-label="match" fontSize="large" />
            </IconButton>
          </Tooltip>
          {!editMode && (
            <Grid
              container
              item
              xs={1}
              justify="center"
              className={classes.middleGrid}
            >
              <Grid item xs={12} className={classes.addButtomItem}>
                {!editMode && (
                  <Tooltip
                    TransitionComponent={Fade}
                    title={t('add more lines')}
                    arrow
                  >
                    <IconButton
                      aria-label="add-lines"
                      onClick={() => addInvoice()}
                      className={classes.addButton}
                    >
                      <AddCircleIcon aria-label="add" fontSize="large" />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          )}
          <Grid container item xs={editMode ? 4 : 5}>
            <Grid container className={classes.container}>
              <Grid item xs={4}>
                <FormLabel className={classes.formLabel}>
                  {t('Ticket Number')}
                </FormLabel>
              </Grid>
              {!editMode && (
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Ticket date')}
                  </FormLabel>
                </Grid>
              )}
              <Grid item xs={editMode ? 4 : 3}>
                <FormLabel className={classes.formLabel}>
                  {t('Maintenance type')}
                </FormLabel>
              </Grid>
              <Grid item xs={editMode ? 3 : 2}>
                <FormLabel className={classes.formLabel}>
                  {t('Historic')}
                </FormLabel>
              </Grid>
              <Grid item xs={1}>
                <FormLabel className={classes.formLabel}>
                  {t('Select')}
                </FormLabel>
              </Grid>
            </Grid>

            {invoices.map((invoice, invoiceIndex) => {
              const ticketNotFoundId = `ticket-${invoiceIndex}`;
              return invoice.maintenanceTicketInvoiceList.length === 0 ? (
                <Grid
                  container
                  key={ticketNotFoundId}
                  spacing={1}
                  className={classes.row}
                >
                  <Grid item xs={4}>
                    <Autocomplete
                      classes={{
                        option: classes.option,
                        input: classes.autocompleteInput,
                      }}
                      className={classes.autocomplete}
                      size="small"
                      freeSolo
                      disabled
                      value={t('not found')}
                      options={[]}
                      renderInput={(params) => (
                        <TextField
                          placeholder={t('Enter Ticket Number')}
                          type="text"
                          variant="outlined"
                          {...params}
                        />
                      )}
                    />
                  </Grid>
                  {!editMode && (
                    <Grid item xs={2}>
                      <FormLabel className={classes.label}>
                        {t('not found')}
                      </FormLabel>
                    </Grid>
                  )}
                  <Grid item xs={editMode ? 4 : 3}>
                    <FormLabel className={classes.label}>
                      {t('not found')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={editMode ? 3 : 2}>
                    <FormLabel className={classes.label}>
                      {t('not found')}
                    </FormLabel>
                  </Grid>
                  <Grid item xs={1} />
                </Grid>
              ) : (
                invoice.maintenanceTicketInvoiceList.map(
                  (ticket, ticketIndex) => {
                    const ticketId = `ticket-${ticketIndex}`;
                    return (
                      <Grid
                        container
                        key={ticketId}
                        spacing={1}
                        className={classes.row}
                        data-testid="ticket"
                      >
                        <Grid item xs={4}>
                          <Autocomplete
                            classes={{
                              option: classes.option,
                              input: classes.autocompleteInput,
                            }}
                            className={classes.autocomplete}
                            size="small"
                            freeSolo
                            inputValue={ticket.ticketNumber}
                            options={getTicketOptionsForWagonNumber(
                              invoiceIndex,
                              ticketIndex,
                              invoice.wagonNumber,
                            )}
                            getOptionLabel={(option) => setOptionLabel(option)}
                            renderInput={(params) => (
                              <TextField
                                data-testid="ticket-number-autocomplete"
                                placeholder={t('Enter Ticket Number')}
                                type="text"
                                variant="outlined"
                                {...params}
                                className={
                                  hasFieldValueError(
                                    invoiceIndex,
                                    'tktSelected',
                                  )
                                    ? classes.inputBoxHighlighted
                                    : ''
                                }
                              />
                            )}
                            getOptionSelected={setOptionSelected}
                            onInputChange={(event, value) =>
                              handleChangeTicketNumberForInvoice(
                                invoiceIndex,
                                ticketIndex,
                                value,
                                event,
                              )
                            }
                          />
                        </Grid>
                        {!editMode && (
                          <Grid item xs={2}>
                            <FormLabel
                              className={
                                hasFieldValueError(invoiceIndex, 'tktSelected')
                                  ? classes.formLabelHighlighted
                                  : classes.label
                              }
                            >
                              {ticket.ticketDate}
                            </FormLabel>
                          </Grid>
                        )}
                        <Grid item xs={editMode ? 4 : 3}>
                          <FormLabel
                            className={
                              hasFieldValueError(invoiceIndex, 'tktSelected')
                                ? classes.formLabelHighlighted
                                : classes.label
                            }
                          >
                            {t(ticket.plannedType)}
                          </FormLabel>
                        </Grid>
                        <Grid
                          item
                          xs={editMode ? 3 : 2}
                          className={classes.grid}
                        >
                          <Button
                            className={classes.historicButton}
                            data-testid="historic"
                            onClick={() =>
                              openHistoricForTicket(ticket.ticketNumber)
                            }
                          >
                            {t(ticket.ticketStatus)}
                          </Button>
                        </Grid>
                        <Grid item xs={1}>
                          {ticket.ticketNumber !== '' &&
                            ticket.selected !== undefined && (
                              <Checkbox
                                className={
                                  ticket.selected
                                    ? classes.checkboxSelected
                                    : classes.checkbox
                                }
                                checked={ticket.selected}
                                onChange={(event) =>
                                  handleSelectedTicket(
                                    ticket.ticketNumber,
                                    invoiceIndex,
                                    event.target.checked,
                                  )
                                }
                                inputProps={{ 'aria-label': 'select-checkbox' }}
                              />
                            )}
                        </Grid>
                      </Grid>
                    );
                  },
                )
              );
            })}
          </Grid>
        </Grid>
      </Paper>
      <HistoricPopUp
        selectedTicketNumber={selectedTicketNumber}
        historicOpened={historicOpened}
        setPopUpOpenedState={closeHistoric}
      />
      <DeleteAllPopUp
        openDeletePopUp={openDeletAllInvoicesPopUp}
        closeDeletePopUp={() => setOpenDeleteAllInvoicesPopUp(false)}
        confirmDeletion={deleteAll}
      />
    </div>
  );
}
